import { Outlet } from 'react-router-dom';

import { PageContent } from '@components/Page';

export const Inventories = () => {
  return (
    <>
      <PageContent>
        <Outlet />
      </PageContent>
    </>
  );
};
